import { useMemo } from 'react'
import { Navigate } from 'react-router-dom'
import { isEmpty } from 'lodash'
import { useSelector } from 'react-redux'

import LoadingSpinner from 'components/LoadingSpinner'
import { useCurrentPractice } from 'contexts/PracticeContext'
import { selectContext } from 'selectors/auth'

import { isIndependentPractice, isRebateEnabled } from 'util/practice'
import { isManagerOrAdmin } from 'util/unified'

const IndependentRebatesGuard = ({ children }) => {
	const context = useSelector(selectContext)
	const { currentPracticeObject } = useCurrentPractice()

	const isRebateIndependentPractice = useMemo(() => {
		return (
			!isEmpty(currentPracticeObject) &&
			isIndependentPractice(currentPracticeObject) &&
			isRebateEnabled(currentPracticeObject)
		)
	}, [currentPracticeObject])

	const isAuthorized =
		isRebateIndependentPractice && isManagerOrAdmin(context, currentPracticeObject)

	if (!currentPracticeObject?.id) {
		return <LoadingSpinner />
	}

	if (!isAuthorized) {
		return <Navigate to="/dashboard" replace />
	}

	return children
}

export default IndependentRebatesGuard
